'use client'

import { usePathname } from 'next/navigation'

/**
 * Hides the marketing footer on the package app, which owns the full viewport.
 *
 * `children` is the real <Footer /> rendered by the (server) root layout and
 * merely passed through this client boundary - so the footer itself stays a
 * server component and marketing pages keep their SSR'd links for SEO.
 */
export default function ConditionalFooter({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  // Matches '/package/...' (English, unprefixed) and '/xx/package/...'
  // (any locale prefix), since `pathname` here is the browser-visible URL,
  // not the internal /en-rewritten path. Also matches '/admin/package/...',
  // the admin-only viewer built on the same full-viewport AppShell.
  if (pathname && /^\/(?:(?:[a-z]{2}(?:-[A-Z]{2})?\/)?package|admin\/package)\//.test(pathname)) return null
  // The live dashboard is a fixed full-viewport, no-scroll view.
  if (pathname === '/admin/live') return null
  return <>{children}</>
}
